import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';
import { InputFieldWithCurrency } from '@/modules/common/components/molecules/inputs/input-field-with-currency';
import { SwitchField } from '@/modules/common/components/molecules/inputs/switch-field';

import {
  FORM_FIELD_ALLOW_CARRYOVER,
  FORM_FIELD_CARRYOVER_DAYS,
} from '../../../../constants/time-off-type-form-fields';
import {
  CARRYOVER_DAYS_MAX_DECIMAL_PLACES,
  CARRYOVER_DAYS_MAX_INTEGER_DIGITS,
  CARRYOVER_DAYS_MIN_VALUE,
  TimeOffTypeSetupFormData,
} from '../../../../validations/time-off-type-validation';

interface CarryoverRulesSectionProps {
  form: UseFormReturn<TimeOffTypeSetupFormData>;
  isReadMode: boolean;
}

export function CarryoverRulesSection({ form, isReadMode }: CarryoverRulesSectionProps) {
  const { t } = useTranslation('authenticated.settings');
  const allowCarryover = form.watch(FORM_FIELD_ALLOW_CARRYOVER);

  return (
    <Card>
      <CardContent className="space-y-4 p-6">
        <div>
          <h3 className="text-md font-semibold">
            {t('pages.timeOff.details.sections.carryover.title')}
          </h3>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {t('pages.timeOff.details.sections.carryover.description')}
          </p>
        </div>

        <SwitchField
          name={FORM_FIELD_ALLOW_CARRYOVER}
          control={form.control}
          label={t('pages.timeOff.details.sections.carryover.allow')}
          disabled={isReadMode}
          onCheckedChange={checked => {
            if (checked && form.getValues(FORM_FIELD_CARRYOVER_DAYS) == null) {
              form.setValue(FORM_FIELD_CARRYOVER_DAYS, CARRYOVER_DAYS_MIN_VALUE);
            }
          }}
        />

        {allowCarryover && (
          <InputFieldWithCurrency
            name={FORM_FIELD_CARRYOVER_DAYS}
            label={t('pages.timeOff.details.sections.carryover.days')}
            control={form.control}
            suffixText="days"
            isReadMode={isReadMode}
            maxIntegerDigits={CARRYOVER_DAYS_MAX_INTEGER_DIGITS}
            maxDecimalPlaces={CARRYOVER_DAYS_MAX_DECIMAL_PLACES}
            minValue={CARRYOVER_DAYS_MIN_VALUE}
          />
        )}
      </CardContent>
    </Card>
  );
}
